import { useState } from "react";

//this custom hook accepts a callback function and delay in ms, and returns a function that clears and sets the timer to run the function
export function useClearableTimeout(callback,delay) {
    // logs describing actions are left here for debugging
    const [timerId,setTimerId] = useState(0);
    // console.log(`Clearable ${delay}ms timeout with timer id ${timerId} that runs:`,callback);

    function resetTimer(...callbackArgs) {
        clearTimeout(timerId);
        // console.log(`Cleared timer ${timerId}`);

        const thisId = setTimeout(() => callback(...callbackArgs), delay);
        // console.log(`Resetting timer to ${thisId}`);
        setTimerId(thisId);
    }

    return resetTimer;
}